import { Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { OnboardingData } from '@zero/shared/util-models';
import { ALLOWED_ONBOARDING_CHARS } from 'constants/shared-constants';

@Injectable({
  providedIn: 'root',
})
export class RegistrationDataHolderService {
  public personData = {} as OnboardingData;
  public isMobileNumberVerified: boolean;
  public readonly mandatoryFieldPattern = `^(?!([0-9 ]))[${ALLOWED_ONBOARDING_CHARS}]+$`;

  constructor(private _authFacade: AuthStateFacade) {
    this._authFacade.loggedIn$.subscribe((loggedIn) => {
      if (!loggedIn) {
        this.personData = {} as OnboardingData;
      }
    });
  }

  public getAddressAsString() {
    return `${this.personData['strasse']} ${this.personData['hausnummer']} ${this.personData['plz']} ${this.personData['ort']} ${this.personData['land']}`;
  }
}
